import type { ILoginButton } from "@src/types/AppTypes";
import React from "react";

const LoginButton: React.FC<ILoginButton> = ({
  attributes,
  className,
  componentRef,
  id,
  onClick,
  title,
}) => {
  return (
    <button
      id={id}
      onClick={
        onClick
          ? onClick
          : () => {
              return;
            }
      }
      ref={componentRef}
      {...attributes}
      className={className}
      aria-label={title}
    >
      {title}
    </button>
  );
};

export default LoginButton;
